module.exports = __webpack_public_path__ + "img/lock.f6b4914e.svg";